import { getConnectorsByAudience } from '@/features/AudienceManager/services';
export const fetchConnectorsByAudience = (audienceId) => {
    return getConnectorsByAudience(audienceId).then(response => formatValue(response?.data));
};
const formatValue = (response) => {
    return {
        data: response?.data?.map(connector => ({
            id: connector.connectorId,
            alias: connector.alias,
            interval: connector.interval,
            hasDatetime: !!connector.startingDate,
            startDatetime: connector.startingDate,
            enabled: connector.active,
            scheduleId: connector.scheduleId,
            lastExecution: connector.lastExecution,
            editable: connector.editable,
            status: connector.status,
            config: connector.config,
            typeSendCampaign: connector.type_send_campaign,
        })),
        errors: response.errors,
        success: response.success,
    };
};
